<template>
    <div class="error white--text text-center ml-2" :class="size">
        Clipboard
    </div>
</template>

<script>
export default {
    name: "CClipboardChip",

    props: {
        size: {
            required: false,
            type    : String,
            default : function () {
                return "medium";
            }
        }
    },
}
</script>

<style scoped>

.medium {
    width: 100px;
    height: 28px;
    border-radius: 14px;
    padding-top: 6px;
}

.small {
    width: 90px;
    height: 22px;
    border-radius: 14px;
    padding-top: 1px;
    font-size: 14px;
    margin-top: 3px
}

.xsmall {
    width: 80px;
    height: 20px;
    border-radius: 14px;
    padding-top: 1px;
    font-size: 12px;
}

</style>